import { icons } from 'common'
import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .content {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .popup .popUpContainer.user-account .content {
    width: 100%;
    align-items: flex-start;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 30px 0 0 0;
    overflow: visible;
  }
  .popup .popUpContainer.user-account .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }
  #user-api_tab_three ~ .user_panels #user-api_panel {
    display: none;
  }
  #user-api_tab_three:checked ~ .user_panels #user-api_panel {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 550px;
    min-height: 350px;
    width: calc(100% - 30px);
    padding: 0 30px 0 0;
    margin: 0 -30px 0 30px;
  }
  .myreferrals_wrapper {
    width: 100%;
  }
  .myreferrals_wrapper .your_referral_link,
  .myreferrals_wrapper .rewards_earned,
  .myreferrals_wrapper .total_referees {
    padding: 0 20px 8px 20px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    margin: 0 0 8px 0;
    align-items: center;
  }
  .myreferrals_wrapper .rewards_earned,
  .myreferrals_wrapper .total_referees {
    border-bottom: 0;
  }
  .myreferrals_wrapper .your_referral_link {
    border-bottom: 0;
    margin: 0 0 5px 0;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .myreferrals_wrapper .your_referral_link .title,
  .myreferrals_wrapper .rewards_earned .title,
  .myreferrals_wrapper .total_referees .title {
    font-size: 0.8rem;
    font-weight: 600;
  }
  .myreferrals_wrapper .your_referral_link .link {
    font-size: 0.9rem;
    font-weight: 200;
    background: hsla(0, 0%, 0%, 0.2);
    border-radius: 6px;
    padding: 12px 16px;
    margin: 5px 0 0 0;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
  .myreferrals_wrapper .your_referral_link .link .copy_icon {
    background: url('http://yolo.tino.me/app_v3/resources/images/icons/copy_icon.svg') center center / 16px no-repeat;
    width: 16px;
    height: 16px;
    margin: 0 0 0 10px;
  }
  .myreferrals_wrapper .your_data {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .myreferrals_wrapper .your_data .rewards_earned,
  .myreferrals_wrapper .your_data .total_referees {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .myreferrals_wrapper .your_data .rewards_earned .box,
  .myreferrals_wrapper .your_data .total_referees .box {
    border-radius: 10px;
    width: 100%;
    height: 80px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 5px 0 0 0;
    font-size: 1.5rem;
    background: hsla(0, 0%, 0%, 0.2);
  }
`

const developerCSS = css`
  div.your_referral_link .link span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 450px;
  }
`

export const UserMyReferralsCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
export const CopyIcon = styled(IconLib).attrs({ dimension: '16px' })`
  width: 12px;
  height: 12px;
  margin: 0 0 0 10px;
`
